export default {"src":"/_next/static/media/twitter.216513c0.svg","height":209,"width":256,"blurWidth":0,"blurHeight":0};